import React from 'react';

const LoadingFallback: React.FC = () => {
  return (
    <div className="flex justify-center items-center h-full min-h-[400px] text-xl text-gray-600 dark:text-gray-300">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-gray-200 dark:border-gray-700 border-t-primary rounded-full animate-spin mx-auto mb-4"></div>
        <p>Loading...</p>
      </div>
    </div>
  );
};

export default LoadingFallback;
